
import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Robert Chen',
      age: 48,
      location: 'Seattle, WA',
      treatment: 'NAD+ IV Therapy Series',
      quote: 'After just two NAD+ treatments, my energy levels skyrocketed and my mental fog completely cleared. I feel 10 years younger and my productivity has never been higher.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/42e4c71966df92ab264d13fd0f51f96b.jpg'
    },
    {
      name: 'Lisa Martinez',
      age: 52,
      location: 'Phoenix, AZ',
      treatment: 'High-Dose NAD+ Protocol',
      quote: 'NAD+ therapy has been transformative for my chronic fatigue. I now have sustained energy throughout the day and my sleep quality has dramatically improved.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20middle-aged%20Hispanic%20woman%2C%20warm%20smile%2C%20business%20casual%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20wellness%20testimonial&width=300&height=300&seq=lisa-nad&orientation=squarish'
    },
    {
      name: 'Mark Thompson',
      age: 45,
      location: 'Chicago, IL',
      treatment: 'NAD+ + Peptide Combination',
      quote: 'The combination of NAD+ and peptides has revolutionized my recovery and performance. As an athlete, this therapy has given me a competitive edge I never thought possible.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Athletic%20middle-aged%20Caucasian%20man%2C%20confident%20expression%2C%20sports%20attire%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20performance%20medicine%20testimonial&width=300&height=300&seq=mark-nad&orientation=squarish'
    },
    {
      name: 'Dr. Amanda Foster',
      age: 41,
      location: 'Boston, MA',
      treatment: 'NAD+ Maintenance Program',
      quote: 'As a physician, I was skeptical until I tried NAD+ therapy myself. The cognitive enhancement and stress resilience I\'ve gained has made me a better doctor and person.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20in%20her%20forties%2C%20confident%20smile%2C%20medical%20coat%2C%20clean%20white%20background%2C%20professional%20headshot%20for%20medical%20testimonial&width=300&height=300&seq=amanda-nad&orientation=squarish'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Life-Changing Results with <strong>NAD+ Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Discover how our patients have transformed their energy, cognition, and overall health with NAD+ therapy.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 lg:p-8">
              <div className="flex items-start space-x-4 mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top"
                />
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">Age {testimonial.age} • {testimonial.location}</p>
                  <p className="text-green-600 text-sm font-medium mt-1">{testimonial.treatment}</p>
                </div>
                <div className="flex space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
              </div>
              
              <blockquote className="text-gray-700 leading-relaxed italic">
                "{testimonial.quote}"
              </blockquote>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-green-50 rounded-2xl p-6 lg:p-8 max-w-4xl mx-auto">
            <div className="grid sm:grid-cols-3 gap-6 lg:gap-8 mb-6">
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">97%</div>
                <div className="text-gray-600">Patient Satisfaction</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">3,000+</div>
                <div className="text-gray-600">NAD+ Treatments</div>
              </div>
              <div>
                <div className="text-2xl lg:text-3xl font-bold text-green-600 mb-2">500%</div>
                <div className="text-gray-600">Average NAD+ Increase</div>
              </div>
            </div>
            <button className="bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Start Your NAD+ Journey
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
